// extracted by mini-css-extract-plugin
export default {"root":"PresentationLink_root__Nx470","icon":"PresentationLink_icon__vesex"};